import { h, Fragment } from "preact";
import { useState, useEffect, useContext, } from "preact/hooks";
import {
	Box,
	Button,
	Checkbox,
	Chip,
	FormControlLabel,
	Grid,
	Paper,
	Stack,
	Typography,

	TextField,
} from "@mui/material";

import { parseISO } from "date-fns";

import DataRoom from "../Common/DataRoom";
import { DatePicker } from '@mui/x-date-pickers';

import SellersCard from "../Common/SellersCard";
import BuyersCard from "../Common/BuyersCard";
import ListOfHours from "../Common/ListOfHours";
import NotariesCard from "../Common/NotariesCard";
import { AppContext } from "../../AppContext";
import { redThreadDealUser } from "../Common/redthread";

export default function DealDashboardN({ id }) {
	const [state, setState] = useState({ actualDeal: undefined });
	const app = useContext(AppContext);

	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dba6598cea0f46da937759765d7358d2/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							actualDeal: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);

	const handleCompromise = (flag) => {
		console.log("handleCompromise", flag);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ no_compromise: flag }),
		};
		fetch("/api/69ccb3e23a9d456d8030d2799f8ec0b8/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload;
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleChangeCheckbox = (event) => {
		setState({ ...state, actualDeal: { ...state.actualDeal, [event.target.name]: event.target.checked } });
		handleCompromise(event.target.checked);
	};

	if (state.actualDeal === undefined) return;

	useEffect(() => {

		redThreadDealUser(state, app);

	}, [state]);


	return (
		<div style="margin-top: 40px; margin-left: 10px; margin-right: 10px;">
			
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Paper style="padding: 10px">
						<Grid container alignItems="center">
							<Grid item xs={6}>
								<Stack spacing={1}>
									<Typography variant="h5">Tableau de bord du dossier {state.actualDeal.lbl_mail}</Typography>
									<Chip
										size="small"
										style="max-width: 300px;"
										label={"Vous êtes notaire " + (state.actualDeal.role === "NV" ? "VENDEUR" : "ACQUEREUR")}
										color="primary" />
								</Stack>
							</Grid>
							<Grid item xs={6}>
								{!state.actualDeal.closed_deal && <Box display="flex" alignItems="center" justifyContent="flex-end" p={1} m={1}>
									<Box>
										<Button>Quitter</Button>
									</Box>
									<Box>
										<Button
											onClick={() => {
												app.refPopUp.current.handleChangeState({

													opened: true,
													type: "002",
													params: {
														yes_action: () => {
															fetch("/api/ca0e1e263452e491aa03d87ee5d6407c/" + id)
																.then((response) => {
																	return response.json();
																})
																.then((res) => {
																	switch (res.res) {
																		case "ok":

																			window.location.reload;
																			break;
																		case "err":
																			break;
																		default:
																			break;
																	}
																});
														},
														title: "Attention",
														body: (
															<div>
																<Typography variant="h5" gutterBottom>
																	Voulez vous vraiment clôturer le dossier ?
																</Typography>
															</div>
														),
													}
												});
											}}
											variant="contained">Clôturer</Button>
									</Box>
								</Box>}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={1}>
						<Grid item xs={12} md={5}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={12}>
									<Paper style="padding: 5px; ">
										<Stack spacing={1}>
											<Typography variant="h5" style="width: 100%; border-bottom: 1px solid rgb(234, 234, 234);">Informations Notaire</Typography>
											{state.actualDeal.auth_signed === 0 && state.actualDeal.cp_signed < 3 && (
												<FormControlLabel
													control={
														<Checkbox
															checked={state.actualDeal.has_compromise_sale}
															onChange={handleChangeCheckbox}
															name="has_compromise_sale"
															color="primary"
														/>
													}
													label="Le dossier de vente comporte un compromis"
												/>
											)}
											{(state.actualDeal.cp_signed > 0 || state.actualDeal.auth_signed === 0) && state.actualDeal.has_compromise_sale && (
												<AppointmentCard
													setState={setState} id={id}
													state={state} date_field="cp_date" time_field={"cp_time"}
													appointment_name="Compromis de vente" mode="C" state_field={"cp"} />
											)}

											<AppointmentCard
												setState={setState} id={id}
												state={state} date_field="authentic_date" time_field={"authentic_time"}
												appointment_name="Acte authentique" mode="A" state_field={"auth"} />

										</Stack>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} md={12}>
									<Paper style="padding: 5px;">
										{state.actualDeal.assets.length > 1 && <Typography variant="h5">Biens</Typography>}
										{state.actualDeal.assets.map((a) => {
											return (<Stack spacing={1}>

												<Typography variant="h5" style="width: 100%;  border-bottom: 1px solid rgb(234, 234, 234);">{a.tp}</Typography>
												<Typography variant="body1">{a.a}</Typography>
												<Typography variant="body1">{a.srf} m2</Typography>
											</Stack>)
										})}
									</Paper>
								</Grid>

								<Grid item xs={12} sm={6} md={12}>
									<SellersCard actualDeal={state.actualDeal} mode="NT" />
								</Grid>

								<Grid item xs={12} sm={6} md={12}>
									<BuyersCard actualDeal={state.actualDeal} mode="NT" />
								</Grid>

								<Grid item xs={12} sm={6} md={12}>
									<NotariesCard actualDeal={state.actualDeal} />
								</Grid>

							</Grid>

						</Grid>
						<Grid item xs={12} md={7}>
							<DataRoom values={state.actualDeal.dr} id={id} archive={state.actualDeal.archive_uid} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div >
	);
}

const AppointmentForm = ({ id, mode, field_name_day, field_name_time }) => {
	const [state, setState] = useState({ actualDeal: undefined });
	const handleChange = (event) => {
		//console.log("handleChange", event.target);
		setState({ ...state, [event.target.name]: event.target.value });
	};
	console.log("AppointmentForm", id, mode, state)

	const handleSendAppointmentInviteMail = (type) => {
		console.log("handleSendAppointmentInviteMail", type)
		var bd;
		if (type === "A") {
			bd = {
				dt: state.authentic_date,
				tm: state.authentic_time,

				type: type
			};
		}
		if (type === "C") {
			bd = {
				dt: state.cp_date,
				tm: state.cp_time,
				type: type
			};
		}
		console.log("bd", bd)
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(bd),
		};
		fetch("/api/081b874a3c004461bb2c59cba08acc3b/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Stack direction="row" spacing={1}>
			{/* <DesktopDatePicker
				inputFormat="dd/MM/yyyy"
				value={state[field_name_day] ? state[field_name_day] : parseISO(new Date())}
				minDate={Date()}
				onChange={(date) =>
					handleChange({
						target: { name: field_name_day, value: date.toISOString() },
					})
				}
				renderInput={(params) => <TextField size="small" placeholder="jj/mm/aaaa" style="max-width: 150px;" {...params} />}
			/> */}
			<DatePicker
				inputFormat="dd/MM/yyyy"
				disablePast
				openTo="month"
				views={['year', 'month', 'day']}
				value={state[field_name_day] ? state[field_name_day] : parseISO(new Date())}
				onChange={(date) =>
					handleChange({
						target: { name: field_name_day, value: date.toISOString() },
					})
				}
				renderInput={(params) => <TextField size="small" placeholder="jj/mm/aaaa" style="max-width: 150px;" {...params} />}
			/>

			<ListOfHours field_name={field_name_time} hour={state[field_name_time]} handleChange={handleChange} />
			<Button
				variant="contained"
				onClick={() => {
					setState({ ...state, auth_signed_mod: false });
					handleSendAppointmentInviteMail(mode);
				}}
			>
				OK
			</Button>
		</Stack>
	);
};

const AppointmentCard = ({ state, setState, handleChange, date_field, time_field, appointment_name, mode, state_field, id }) => {

	const handleSendAppointmentDone = (type) => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ type: type }),
		};
		fetch("/api/dce755b0fa97427aa88dfeb26cb6f1c0/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	const handleSendAppointmentCanceled = (type) => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ type: type }),
		};
		fetch("/api/2c4193ebe0734f2a88410bdf3a26ca67/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	//console.log("AppointmentCard", state_field, state.actualDeal[state_field + "_signed"])
	return (<Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">

		{state.actualDeal[state_field + "_signed"] === 0 && state[state_field + "_signed_mod"] === undefined && (
			<Fragment>
				<Typography variant="body1">{appointment_name}</Typography>
				<Button
					variant="contained"
					onClick={() => {
						//console.log("******")
						setState({ ...state, [state_field + "_signed_mod"]: true });
					}}
				>
					Proposer un rendez-vous
				</Button>
			</Fragment>

		)}
		{state.actualDeal[state_field + "_signed"] === 0 && state[state_field + "_signed_mod"] !== undefined && (
			<Fragment>
				<Typography variant="body1">{appointment_name}</Typography>
				<AppointmentForm
					field_name_day={date_field}
					field_name_time={time_field}
					handleChange={handleChange}
					state={state}
					setState={setState}
					mode={mode}
					id={id}
				/>
			</Fragment>
		)}

		{state.actualDeal[state_field + "_signed"] == 1 && (
			<Fragment>
				<Typography variant="body1">{appointment_name}</Typography>
				<Typography variant="body1">
					{new Date(state.actualDeal[state_field + "_date"]).toLocaleString("fr-FR", {
						timeZone: "UTC",
						weekday: "long",
						year: "numeric",
						month: "numeric",
						day: "numeric",
						hour: "numeric",
						minute: "numeric",
					})}
				</Typography>
				<Button
					variant="outlined"
					onClick={() => {
						handleSendAppointmentCanceled(mode);
					}}
				>
					Annulé
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						handleSendAppointmentDone(mode);
					}}
				>
					effectué
				</Button>
			</Fragment>
		)}
		{state.actualDeal[state_field + "_signed"] == 2 && (
			<Typography variant="body1">{appointment_name} signé le&nbsp;
				{new Date(state.actualDeal[state_field + "_date"]).toLocaleString("fr-FR", {
					timeZone: "UTC",
					weekday: "long",
					year: "numeric",
					month: "numeric",
					day: "numeric",
					hour: "numeric",
					minute: "numeric",
				})}
			</Typography>
		)}
	</Stack>)
}

